type ChatEntry = {
  entryType: string;
  createdAt: number;
};

export function lastPersonalChatMessageAt(
  entries: readonly ChatEntry[] | undefined,
  createdAt: number
) {
  let latest = createdAt;
  for (const entry of entries ?? []) {
    if (entry.entryType === "UserMessage") {
      latest = Math.max(latest, entry.createdAt);
    }
  }
  return latest;
}

export const PERSONAL_CHAT_TIDY_DAYS = 14;

type TidyableChat = {
  id: string;
  createdAt: number;
  lastActiveAt: number;
  pinnedAt: number | null;
  userChangedNameAt: number | null;
  chat?:
    | {
        respondingAt: number | null;
        awaitingAction: boolean | null;
        entries: readonly ChatEntry[];
      }
    | undefined;
};

// Chats people dip into occasionally gain follow-ups or recent opens, so only
// empty chats and long-abandoned one-off questions are offered.
export function isPersonalChatTidyable(
  chat: TidyableChat,
  activeChatId: string | undefined,
  now = Date.now()
) {
  if (
    chat.id === activeChatId ||
    chat.pinnedAt != null ||
    chat.userChangedNameAt != null ||
    chat.chat?.respondingAt != null ||
    chat.chat?.awaitingAction
  ) {
    return false;
  }
  const userMessages = (chat.chat?.entries ?? []).filter(
    (e) => e.entryType === "UserMessage"
  ).length;
  if (userMessages === 0) return true;
  if (userMessages > 1) return false;
  return (
    Math.max(
      chat.lastActiveAt,
      lastPersonalChatMessageAt(chat.chat?.entries, chat.createdAt)
    ) <
    now - PERSONAL_CHAT_TIDY_DAYS * 24 * 60 * 60 * 1000
  );
}
